import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

class DiscountService {
  addPromotionProduct(promotionProductAddModel) {
    return api.post(
      UtilsUrl.discountURL() + "/addPromotionProduct",
      promotionProductAddModel
    );
  }
  addPromotionCart(promotionCartAddModel) {
    return api.post(
      UtilsUrl.discountURL() + "/addPromotionCart",
      promotionCartAddModel
    );
  }
  allDiscounts(idUser, isActive, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/allDiscounts/" +
        idUser +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }
 

  allDeclencheurs(idUser, isActive, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/allDeclencheurs/" +
        idUser +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }
    getDeclencheursById(idUser, idDeclencheur) {
    return api.get(
      UtilsUrl.discountURL() +
        "/getDeclencheurById/" +
        idUser +
        "/" +
        idDeclencheur
    );
  }
  allDiscountsTypeDiscount(idUser, isActive, isDeleted, type) {
    return api.get(
      UtilsUrl.discountURL() +
        "/allDiscountsTypeDiscount/" +
        idUser +
        "/" +
        isActive +
        "/" +
        isDeleted +
        "/" +
        type
    );
  }
  allRulesByWarehouse(rule) {
    return api.post(UtilsUrl.discountURL() + "/allRulesByWarehouse", rule);
  }
  addPriorityRules(priorityRule) {
    return api.post(UtilsUrl.discountURL() + "/addPriorityRules", priorityRule);
  }
  addDeclencheur(addDeclencheurModel) {
    return api.post(
      UtilsUrl.discountURL() + "/addDeclencheur",
      addDeclencheurModel
    );
  }
// conditions commercial tiers


allConditionsCommercialTiers(idUser, isActive, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/allConditionsCommercialTiers/" +
        idUser +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }

  archiveConditionCommercial(idConditionCommercial, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/archiveConditionCommercial/" +
        idConditionCommercial +
        "/" +
        isDeleted
    );
  }

    desactiverDeclencheur(idUser,idDeclencheur, isActive) {
    return api.get(
      UtilsUrl.discountURL() +
        "/desactiverDeclencheur/" +idUser+
        "/" +
        idDeclencheur +
        "/" +
        isActive
    );
  }

      desactiverDiscount(idUser,idDiscount, isActive) {
    return api.get(
      UtilsUrl.discountURL() +
        "/desactiverDiscount/" +idUser+
        "/" +
        idDiscount +
        "/" +
        isActive
    );
  }
  addConditionsCommercialTiers(promotionCCAddModel) {
    return api.post(
      UtilsUrl.discountURL() +
        "/addConditionCommercialTiers",promotionCCAddModel
    );
  }

  updateDeclencheurRemoveDiscountById(model) {
    return api.post(
      UtilsUrl.discountURL() +
        "/updateDeclencheurRemoveDiscountById",model
    );
  }
    updateDeclencheurAddDiscountById(model) {
    return api.post(
      UtilsUrl.discountURL() +
        "/updateDeclencheurDiscountById",model
    );
  }
   updateDeclencheurDateById(model) {
    return api.post(
      UtilsUrl.discountURL() +
        "/updateDeclencheurDateById",model
    );
  }
  addConditionCommercialTiersToPartnerClient(promotionCCAddModel) {
    return api.post(
      UtilsUrl.discountURL() +
        "/addConditionCommercialTiersToPartnerClient",promotionCCAddModel
    );
  }
  addConditionCommercialTiersToPartnerFournisseur(promotionCCAddModel) {
    return api.post(
      UtilsUrl.discountURL() +
        "/addConditionCommercialTiersToPartnerFournisseur",promotionCCAddModel
    );
  }
  allConditionsCommercialTiersPartnerClient(idUser, isActive, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/allConditionsCommercialTiersPartnerClient/" +
        idUser +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }

  allConditionsCommercialTiersPartnerFournisseur(idUser, isActive, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/allConditionsCommercialTiersPartnerFournisseur/" +
        idUser +
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }

  getConditionsCommercialTiersByClient(idUser,idClient, isActive, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/getConditionsCommercialTiersByClient/" +
        idUser +"/" +idClient+
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }

  getConditionsCommercialTiersByFournisseur(idUser,idFournisseur, isActive, isDeleted) {
    return api.get(
      UtilsUrl.discountURL() +
        "/getConditionsCommercialTiersByFournisseur/" +
        idUser +"/" +idFournisseur+
        "/" +
        isActive +
        "/" +
        isDeleted
    );
  }



}
export default new DiscountService();
